import { FC, FunctionComponent, useContext, useEffect, useState} from "react";
import DashboardSideBar from "../../components/shared-components/dashboard/DashboardSideBar";
import DashboardHeader from "../../components/shared-components/dashboard/DashboardHeader";
import styles from "./DashboardLayout.module.css";
import { ToastContainer } from "react-toastify";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_USER_PROFILE, UPDATE_USER_DEVICE_TOKEN } from "../../features/Auth/api/SignInQuery";
import ToasterWithMessage from '../../components/shared-components/toaster/index'
import { globalContext } from "../../Provider/AppProvider";
import { firebase } from "../../config/firebaseconfig";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { register } from "../../serviceWorkerRegistration";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import { getFormattedDate, roles } from "../../helper";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
interface ProType {
  component: FunctionComponent;
}

const DashboardLayout: FC<ProType> = ({ component: Component }) => {
  const {error} = ToasterWithMessage();
  const [loading,setLoading] = useState(false);
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [deviceToken,setDeviceToken] = useState("");
  const [existingDeviceToken,setExistingDeviceToken] = useState<string[]>([]);
  const[userId,setUserId] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
  const date = getFormattedDate(new Date());
  const {pathname} = useLocation();


  const [updateUserDeviceToken] = useMutation(UPDATE_USER_DEVICE_TOKEN)
  
  const [getUserProfile] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: "no-cache",
    onCompleted: (userdata) => {
      const adminFName = userdata?.get_user_profile[0]?.u_first_name;
      const adminLName = userdata?.get_user_profile[0]?.u_last_name;
      const mailId =userdata?.get_user_profile[0]?.u_email_id;
      const avatar = userdata?.get_user_profile[0]?.u_avatar_url;
      const phoneNumber = userdata?.get_user_profile[0]?.u_phone_number;
      const userId = userdata?.get_user_profile[0]?.u_id;
      const userRole=userdata?.get_user_profile[0]?.u_role;
      const allowedRoles = userdata?.get_user_profile?.[0]?.u_allowed_roles?.filter((role: string) => role === roles.AFFILIATER_ADMIN || role === roles.SUPER_USER);
      const tempData = {...globalState}
      tempData.profile.id = userId? userId:"";
      tempData.profile.firstName = adminFName ? adminFName : tempData?.profile?.firstName
      tempData.profile.lastName =(adminLName && adminLName.trim() !== '')? adminLName: adminLName === ''? '': tempData?.profile?.lastName ;
      tempData.profile.mailId = mailId ? mailId : tempData?.profile?.mailId
      tempData.profile.photo = avatar ? avatar : tempData?.profile?.photo
      tempData.profile.phonenumber = phoneNumber ? phoneNumber : tempData?.profile?.phonenumber
      tempData.profile.profileUpdate = false;
      tempData.profile.userRole = allowedRoles?.length ? allowedRoles[0] : userRole?userRole:tempData.profile.userRole
      handleGlobalState({...tempData,tempData});
      setLoading(false);
      setUserId(userId);
      setExistingDeviceToken(userdata?.get_user_profile[0]?.u_device_tokens)
    },
    onError: ()=>{
        setLoading(false)
        error("Something went wrong!");
    }
  });

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

  useEffect(()=>{
    if(globalState?.profile?.profileUpdate){
      setLoading(true);
      getUserProfile();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState?.profile?.profileUpdate])
  useEffect(()=>{
    setLoading(true);
    getUserProfile();
    getDeviceToken();
    if(globalState.profile.userRole !== "marketing_user"){
      getWebNotification({
        variables:{
          todayDate: date,
          userId: globalState?.profile?.id
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);


  const messaging = getMessaging(firebase);

  const getDeviceToken = async () => {
    try {
      // Request permission for notifications
      
      const permission = await Notification.requestPermission();
      
      if (permission === 'granted') {
        
        const serviceWorkerRegistration = await register();
        const currentToken = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_VAPID_KEY,
          serviceWorkerRegistration: serviceWorkerRegistration,
        });
  
        if (currentToken) {
          const tempData = {...globalState};
          tempData.profile.deviceToken = currentToken;
          handleGlobalState(tempData);
          setDeviceToken(currentToken);
        }
      }
    } catch (err: any) {
      //  error("Something went wrong while get device token!");
    }
  };
  
    onMessage(messaging, (payload) => {
    const {data} = payload;
    const title = data?.title || "Message"
  
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted'){
        const notification = new Notification(title, {
          icon: data?.imageUrl,
        });
      }
    }).catch((err: any) => {
    });
    if(globalState.profile.userRole !== "marketing_user"){
      getWebNotification({
        variables:{
          todayDate: date
        }
      })
    }
  });

  useEffect(()=>{
    if(deviceToken && !loading && userId){
      if(!existingDeviceToken){
        updateUserDeviceToken({
          variables:{
            userId: userId,
            deviceToken: deviceToken
          }
        })

      }else{
        if(!existingDeviceToken.includes(deviceToken)){
          updateUserDeviceToken({
            variables:{
              userId: userId,
              deviceToken:deviceToken
            }
          })

        }
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[deviceToken,loading,userId])


  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <>
    <div className={styles.adminDashboard}>
      <DashboardSideBar showSidebar={showSidebar} />
      <div className={styles.separator} onClick={toggleSidebar}>
        <div className={styles.arrowdiv}>
      {showSidebar? <ArrowBackIosIcon className={styles.arrowIconForward}/>: <ArrowForwardIosIcon className={styles.arrowIconBack} fontSize="small"/>}
      </div>
      </div>
      <div className={showSidebar ?styles.dashboardLayoutMainStyle : styles.dashboardLayoutMainStylehidesidebar}>
        <DashboardHeader loadingUserProfile={loading}/>
        <div className={styles.mainContent} style={{height: `${(pathname === "/new-list" || (globalState.profile.userRole === roles.SUPER_USER && pathname === "/dashboard")) ? "100vh" : ""}`}}>
        <ToastContainer 
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
          {loading?
          <div className={styles.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>:
          <Component />
          } 
      </div>
      </div>
    </div>
    </>
  );
};
export default DashboardLayout;
